/**
 * @generated SignedSource<<6e79d7e91841e4e473523c5c0b317e16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BlogPostStatusEnum = "approved" | "draft" | "published";
import { FragmentRefs } from "relay-runtime";
export type MetaInfo_BlogPostFragment$data = {
  readonly status: BlogPostStatusEnum | null | undefined;
  readonly updatedAt: string | null | undefined;
  readonly user: {
    readonly avatarUrl: string | null | undefined;
    readonly name: string | null | undefined;
    readonly profile: {
      readonly slug: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "MetaInfo_BlogPostFragment";
};
export type MetaInfo_BlogPostFragment$key = {
  readonly " $data"?: MetaInfo_BlogPostFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MetaInfo_BlogPostFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MetaInfo_BlogPostFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BlogPost",
  "abstractKey": null
};

(node as any).hash = "44241df8524c5fee3a100da36216ecdd";

export default node;
